export const alertConstants = {
  SUCCESS: 'ALERT_SUCCESS',
  WARNING: 'ALERT_WARNING',
  ERROR: 'ALERT_ERROR',
  CLEAR: 'ALERT_CLEAR'
}
